const createEvent = (type) => {
  const options = { bubbles: true, cancelable: true };
  if (typeof Event === "function") {
    return new Event(type, options);
  }
  const event = document.createEvent("Event");
  event.initEvent(type, options.bubbles, options.cancelable);
  return event;
};
export default createEvent;
